import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'fc-image-placeholder',
  imports: [],
  template: `
    <div
      [style.backgroundImage]="'url(' + imagePlaceholder + ')'"
      [style.backgroundSize]="placeholderSize"
      [style.minWidth.px]="thumbWidth"
      [style.height.px]="thumbHeight"
      class="photo-placeholder {{ imageForm }}"
    ></div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      @use 'var' as *;

      .photo-placeholder {
        width: 100%;
        height: 100%;
        background-color: $secondary-100;
        border-radius: 4px;
        overflow: hidden;
        background-size: auto;
        background-repeat: no-repeat;
        background-position: 50%;
      }

      .circle {
        border-radius: 100%;
        overflow: hidden;
      }
    `,
  ],
})
export class ImagePlaceholderComponent {
  @Input({ required: true }) thumbWidth: number;
  @Input({ required: true }) thumbHeight: number;
  @Input() imagePlaceholder = '/assets/icons/vehicle-icon.svg';
  @Input() placeholderSize = 'auto';
  @Input() imageForm: 'auto' | 'circle' = 'auto';
}
